module.exports = __webpack_public_path__ + "media/images/user3-128x128-8a7ea24cea1ce1e34fd9439dbcab7b57.jpg";